const translationCZ = {
  'About Us': 'O nás',
  'SwapAround is a new social network for swapping. You can swap anything, your surpluses, items or services. Anything you can think of and responds to our categories.':
    'SwapAround je nová sociální síť pro směnný obchod. Směňovat aneb měnit “něco za něco” můžete jakékoliv věci, své přebytky, služby, cokoliv, co vás napadne a odpovídá našim kategoriím.',

  'How do I use SwapAround?': 'Jak se používá SwapAround?',
  'Do I necessarily have to ask only for surpluses for my Offers?':
    'Musím nutně požadovat výměnou přebytky?',
  'What are SwapAroud policies?': 'Jaké jsou zásady SwapAround?',
  'What do I need to create a profile?': 'Co potřebuji k vytvoření profilu?',
  'What kind of profile photo should I upload?':
    'Jakou fotku bych měl nahrát jako profilovou?',
  'When will my Offers go online?':
    'Kdy budou moje nabídky k dispozici online?',
  'What do I get for the membership I pay to SwapAround?':
    'Co dostanu za členství, které na SwapAround platím?',

  //1
  '<ol> <li>SwapAround has the easiest possible manipulation. Even elderly people can manage. The User signs to be either an &bdquo;I seek&ldquo; or an &bdquo;I Offer&ldquo; User. Everyone can be both and switch in their account between the profiles. Users can log in with an email address, Facebook account or Google account.</li> <li>You must fill all profile details, including a short introduction e.g. &ldquo;Ecology mined woman on maternity leave who likes to give new life to old things&rdquo;, &ldquo;Stay at home mother who welcomes every item for her household&rdquo; and upload a profile picture.</li> <li>As &bdquo;I Offer&ldquo; user, you create your Offer (plus icon on &bdquo;I Offer &lsquo;s&ldquo; profile) &ndash; it can be anything &ndash; things you don&rsquo;t need anymore, things you make and you welcome to swap them for other things, services you provide and want to swap them for other services or items. You have to upload a picture of your Offer, fill the description, write down for what you want to swap them, how many portions/items/seats you have available, date and time of availability and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with the &bdquo;I seek&ldquo; User about an additional questions regarding your Offer.&nbsp;</li> <li>As a Guest you set filters &ndash; distance from the place where you are located at the moment, time, category of item you are seeking or use a key word search. Then SwapAround gives you matches with the Offers and you can start browsing.&nbsp;</li> <li>After Swap is due, you can rate under each profile, which builds trust in the community.</li> <li>When you see that a User on the other side is violating our Terms and Conditions, you can report them.</li> </ol>': `<ol>
  <li>SwapAround m&aacute; to nejjednodu&scaron;&scaron;&iacute; možn&eacute; ovl&aacute;d&aacute;n&iacute;, kter&eacute; bez obt&iacute;ž&iacute; zvl&aacute;dnou i star&scaron;&iacute; lid&eacute;. Uživatel vytvoř&iacute; svůj profil jako &bdquo;Nab&iacute;z&iacute;m&ldquo; nebo &bdquo;Hled&aacute;m&ldquo; nebo oboj&iacute; a pokud m&aacute; oba profily, může mezi nimi jednodu&scaron;e přep&iacute;nat. Registrace profilu je možn&aacute; pomoc&iacute; emailov&eacute; adresy, Facebookov&eacute;ho &uacute;čtu nebo Google &uacute;čtu.</li>
  <li>Jako uživatel &bdquo;Nab&iacute;z&iacute;m&ldquo; mus&iacute;te vyplnit v&scaron;echny detaily profilu včetně kr&aacute;tk&eacute;ho představen&iacute;, jako např&iacute;klad: &bdquo;Jsem pracuj&iacute;c&iacute; žena a zaj&iacute;m&aacute;m se o ekologii, proto r&aacute;da swapuju.&ldquo; nebo &bdquo;Jsme společnost, kter&aacute; sv&eacute; v&yacute;robky r&aacute;da vyměn&iacute; za jin&eacute; v&yacute;robky nebo služby&ldquo;. Pak už jen nahrajete profilovou fotku.</li>
  <li>Hned potom můžete vytv&aacute;řet sv&eacute; nab&iacute;dky (tlač&iacute;tko &bdquo;plus&ldquo; na Va&scaron;em profilu). Nab&iacute;zet můžete cokoliv: věci, kter&eacute; už nepotřebujete, věci, kter&eacute; jste dostali jako nevhodn&yacute; d&aacute;rek nebo jste je koupili prostě nav&iacute;c. Služby, kter&eacute; nab&iacute;z&iacute;te v&yacute;měnou za jin&eacute; služby nebo věci. Fantazii se meze nekladou. U každ&eacute; Nab&iacute;dky mus&iacute;te nahr&aacute;t fotku, vyplnit popisek, naspat za co ji chcete swapovat, v&nbsp;př&iacute;padě vařen&iacute;ch j&iacute;del, kter&eacute; chcete měnit za např&iacute;klad ingredience do nich, napi&scaron;te, kolik porc&iacute; je k&nbsp;dispozici. Stejně tak nezapomeňte uv&eacute;st, kde chcete v&yacute;měnu realizovat. O Objedn&aacute;vce dostanete upozorněn&iacute; do v&aacute;mi uveden&eacute;ho mailu. S&nbsp;Uživatelem, kter&yacute; si Nab&iacute;dku objedn&aacute;, můžete probrat dal&scaron;&iacute; věci t&yacute;kaj&iacute;c&iacute; se Objedn&aacute;vky, jako např&iacute;klad v kolik přesně doraz&iacute;.&nbsp;</li>
  <li>Jako uživatel &bdquo;Popt&aacute;v&aacute;m&ldquo; nastavte předev&scaron;&iacute;m spr&aacute;vně sv&eacute; filtry: kategorii, co popt&aacute;v&aacute;te a vzd&aacute;lenost, kam jste ochotni si pro Nab&iacute;dku přijet od m&iacute;sta, kde se nach&aacute;z&iacute;te. Stejně tak můžete využ&iacute;t vyhled&aacute;vače podle kl&iacute;čov&yacute;ch slov. SwapAround v&aacute;m nab&iacute;dne shody s&nbsp;Va&scaron;im vyhled&aacute;v&aacute;n&iacute;m a ty uvid&iacute;te jako Nab&iacute;dky, kter&eacute; můžete snadno proch&aacute;zet.&nbsp;</li>
  <li>Po skončen&iacute; Swapu můžete jeden druh&eacute;ho hodnotit, což zvy&scaron;uje důvěru v&nbsp;r&aacute;mci SwapAround komunity.</li>
  <li>Pokud vid&iacute;te, že jak&yacute;koliv Uživatel poru&scaron;uje na&scaron;e Obchodn&iacute; Podm&iacute;nky, pros&iacute;m, nahla&scaron;te ho.</li>
  </ol>`,

  //2
  '<p>Not at all. It is only about demand and supply. If people accept your Offers swapped for services or new items, it is totally up to you what you ask for. The only thing you can not ask for is money.</p>':
    '<p>Ne, můžete požadovat cokoliv &ndash; věci, služby, n&aacute;kup nov&yacute;ch věc&iacute;. Vždy je to o tom, zda druh&aacute; strana je ochotna na va&scaron;&iacute; Nab&iacute;dku přistoupit. Klidně si za židli řekněte o n&aacute;kup něčeho specifick&eacute;ho, pro co druh&aacute; strana mus&iacute; do obchodu, ale poř&aacute;d je to pro ni v&yacute;hodněj&scaron;&iacute;, než kdyby měla danou věc kupovat. Jedin&eacute;, o co si na Platfromě SwapAround ř&iacute;ci nemůžete, jsou pen&iacute;ze.</p>',
  //3
  '<p>SwapAround has a strict non-discrimination policy. SwapAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms.<br />The SwapAround community is committed to building a world where people from every background feel welcome and respected. This commitment rests on two foundational principles that apply all to SwapAround Users inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on SwapAround no matter who they are, where they come from, how they worship, or whom they love.</p>':
    '<p>SwapAround m&aacute; př&iacute;snou antidiskriminačn&iacute; politiku. SwapAround je ve sv&eacute;m j&aacute;dru otevřen&aacute; komunita, jej&iacute;mž c&iacute;lem je sbližov&aacute;n&iacute; lid&iacute; z&nbsp;cel&eacute;ho světa. V&nbsp;komunitě SwapAround jsou lid&eacute; prakticky ze v&scaron;ech zem&iacute; a kultur.<br />Platforma SwapAround se zav&aacute;zala budovat svět, ve kter&eacute;m se lid&eacute; ze v&scaron;ech prostřed&iacute; c&iacute;t&iacute; v&iacute;t&aacute;ni a respektov&aacute;ni, bez ohledu na to, jak daleko odcestovali z domova. Tento z&aacute;vazek spoč&iacute;v&aacute; na dvou z&aacute;kladn&iacute;ch principech, kter&eacute; plat&iacute; pro v&scaron;echny Uživatele SwapAround: toleranci a respekt. N&aacute;&scaron; společn&yacute; z&aacute;vazek k těmto principům umožňuje každ&eacute;mu uživateli c&iacute;tit se na SwapAround v&iacute;t&aacute;ni bez ohledu na to, kdo jsou, odkud poch&aacute;zej&iacute;, jak uct&iacute;vaj&iacute; nebo koho miluj&iacute;.</p>',
  //4
  '<p>Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes.</p>':
    '<p>Pouze chytr&yacute; telefon nebo tablet nebo laptop nebo poč&iacute;tač. Vytvořen&iacute; profilu na Pltafromě SwapAround zabere zhruba 10 minut.</p>',
  //5
  '<p>It has to be a genuine photo of yourself.</p>':
    '<p>Opravdovou fotku va&scaron;&iacute; osoby. Pokud tam vytvoř&iacute;te profil jako společnost, můžete d&aacute;t logo nebo jinou fotku reprezentuj&iacute;c&iacute; pr&aacute;vnickou entitu.</p>',
  //6
  '<p> Immediately. You don‘t have to wait for any approval. </p>':
    '<p>Okamžitě. Nepodl&eacute;haj&iacute; ž&aacute;dn&eacute;mu schvalov&aacute;n&iacute;.</p>',
  //7
  '<p>A powerful online presence and technical support. SwapAround actively markets your Offers. A dedicated team verifies Users &sbquo; reviews, making sure they are legitimate. This gives you credibility and helps future swappers make the decision to stay with you. 24/7 support is here for you and your swappers.</p>':
    '<p>SwapAround aktivně zveřejňuje va&scaron;e nab&iacute;dky, naplno funguj&iacute;c&iacute; t&yacute;m ověřuje recenze a zaji&scaron;ťuje neust&aacute;l&yacute; chod t&eacute;to soci&aacute;ln&iacute; s&iacute;tě, včetně technick&eacute;ho servisu a z&aacute;kaznick&eacute; podpory, na kterou můžete ps&aacute;t 24 hodin, 7 dn&iacute; v&nbsp;t&yacute;dnu.</p>',

  //App translation
  SEARCH_FOR: 'Hledat...',
  'Became i seek': `Chci Hledám`,
  'Became i offer': `Chci Nabízím`,
  Seek: 'Poptávka',
  Offer: 'Nabídka',
  Profile: `Profil`,
  'Payment Card': `Platební Karta`,
  Settings: `Nastavení`,
  Share: `Sdílet`,
  'Bank account': `Bankovní účet`,
  Logout: `Odhlásit se`,
  'Contact Support': `Kontaktovat podporu`,
  'Contact Us': `Kontaktujte Nás`,
  FAQ: 'FAQ',
  'Terms and Conditions': 'Pravidla a Podmínky',
  'Edit Profile': `Editovat Profil`,
  'My Account': `Můj účet`,
  'Push Notifications': `Oznámení push`,
  'Sign out': 'Odhlásit se',
  'Current Orders': `Aktuální objednávky`,
  'Past Orders': `Minulé objednávky`,
  'Newest First': `Nejnovější první`,
  Oldest: `Nejstarší`,
  'Filter by': `Filtrovat podle`,
  'Have any question or need help?': `Máte dotaz nebo potřebujete pomoc?`,
  'Feel free to write us. We will answer you as soon as possible.': `Neváhejte a napište nám. Odpovíme vám co nejdříve.`,
  Send: `Poslat`,
  'My Offer': `Moje nabídka`,
  'User Reviews': `Uživatelské Recenze`,
  'Meal Details': 'Detaily jídla',
  'Order Details': `Podrobnosti o objednávce`,
  'Cannot find offers': `Nelze najít nabídky`,
  'Searching Offers around': `Hledání nabídek v okolí`,
  Order: 'Vyměnit',
  Save: 'Uložit',
  'Currently you have no past orders': `Momentálně nemáte žádné předchozí objednávky`,
  'Currently you have no orders': `Momentálně nemáte žádné objednávky`,
  'Back to my orders': 'Zpět na mé objednávky',
  'Waiting for Accept': 'Čekání na přijetí',
  Refused: 'Odmítnuto',
  Ready: 'Připraveno',
  'Ready in': `Připraveno v`,
  ARRIVE_IN: 'Příjezd v',
  'per item': 'položka',
  Quantity: 'Množství',
  Available: 'K dispozici',
  'I offers Details': 'Nabízím Podrobnosti',
  'I seeks Details': 'Hledám Podrobnosti',
  'i offer': 'Nabízím',
  'i seek': 'Hledám',
  'Take away': 'Vzít s sebou',
  'Eat with': 'Jíst spolu',
  Both: 'Oba',
  'Total Price': `Konečná cena`,
  'Your Payout': 'Vaše výplata',
  Cook: 'Nabízím',
  Guest: 'Hledám',
  Cooks: 'Nabízím',
  Guests: 'Hledám',
  'Currently the cooks have no added offer':
    'V současné době kuchaři nemají přidanou nabídku',
  'Report i offer': 'Zpráva nabízím',
  'Report i seek': 'Hlášení hledám',
  Cancel: 'Zrušení',
  'New Offer': 'Nová nabídka',
  General: 'Všeobecné',
  'Number of items available': 'Počet dostupných Položek',
  'Price per portion/item': 'Cena za porci / kus',
  'Date and Time': 'Datum a čas',
  CONSUMPTION_TYPE_MESSAGE:
    'Je dostupné ke konzumaci s Kuchařem, což znamená, že Host ho může sníst u Kuchaře doma.',
  NO_OFFER_LISTED: 'Nemáte žádnou vytvořenou žádnou nabídku',
  Done: 'Hotovo',
  Category: 'Kategorie',
  Select: 'Vyber',
  Name: 'jméno',
  Description: 'Popis',
  Restrictions: 'Omezení',
  'Type of Consumption': 'Způsob konzumace',
  TODAY: 'Dnes',
  YESTEDAY: 'Včera',
  RATE_YOUR_GUEST: 'Ohodnoť svého Hosta!',
  RATE_YOUR_COOK: 'Ohodnoť svého Kuchaře!',
  WRITE_A_NOTE: 'Napište poznámku',
  CHANGE_PASSWORD: 'Změnit heslo',
  RESET_PASSWORD: 'Resetovat heslo',
  RESET_YOUR_PASSWORD: 'Resetujte své heslo',
  RESET_PASSWORD_SUCCESSFUL: 'Vaše heslo bylo úspěšně změněno.',
  YOUR_EMAIL: `váš email`,
  WRITE_MESSAGE: 'Napište vaší zprávu',
  DETAILS: 'Detail',
  ADD_OFFER: 'Přidat nabídku',
  MEAL_NOT_EXISTS: 'Jídlo neexistuje',
  DELETE: 'Vymazat',
  DELETE_MESSAGE: 'Opravdu chcete tuto nabídku smazat?',
  NO_REVIEWS: 'Zatím žádné recenze',
  USERNAME: 'Uživatelské jméno',
  PHONE_NUMBER: 'Telefonní číslo',
  STREET: 'Ulice',
  CITY: 'Město',
  NOTE: 'Poznámka',
  ZIP_CODE: `PSČ`,
  REGION: 'Kraj',
  CONSTANT_OFFER: 'Stálá Nabídka',
  'a.m': 'Dopoledne',
  'p.m': 'Odpoledne',
  Evening: 'Večer',
  AVAILABLE_DATES: 'Dostupná data',
  VIEW_DATES: 'zobrazit dostupná data',
  NO_DATES: 'data nejsou k dispozici',
  TIME_SCHEDULE: 'Časový harmonogram',
  NO_TIME_SCHEDULE: 'Žádný časový plán',
  'New Card': 'Nová karta',

  MY_ORDERS: 'Moje Objednávky',
  MY_OFFERS: 'Moje Nabídky',
  GO_TO_OFFERS: 'Jít na Moje Nabídky',
  GO_TO_ORDERS: 'Jít na Moje Objednávky',
  YOUR_OFFER: 'Vaše objednávka',
  WAS_DELETED: 'byla smazána Adminem',

  NOTIFICATIONS: 'Notifikace ',
  NEW_ORDER: 'Nová objednávka ',
  ORDER_ACCEPTED_NOTIFICATION: 'Přijatá objednávka',
  ORDER_REFUSED_NOTIFICATION: 'Objednávka odmítnuta',
  NEW_ORDER_NOTIFICATION_MESSAGE: 'Máte novou objednávku',
  OFFER_DELETED: 'Nabídka vymazána',
  OFFER_DELETED_NOTIFICATION_MESSAGE: 'Vaše objednávka byla vymazána Adminem',
  Reason: 'Důvod',
  SWITCH_ACCOUNT_MESSAGE:
    'Prosím, přepněte si účet pro zhlédnutí této Objednávky ',

  //Modals
  ORDER_ACCEPTED: 'Přijali jste objednávku!',
  Continue: 'Pokračovat',
  ACCEPT: 'Přijmout',
  REPORT_REASON: 'Váš důvod byl zaslán hostovi.',
  'Write a reason of reporting': `Napište důvod hlášení`,
  REFUSE_ORDER: 'Odmítněte objednávku',
  ACCEPTED_ORDER: 'Vaše objednávka byla přijata!',
  PICKUP_ADDRESS: 'Vyzvedněte objednávku na následující adrese na adrese',
  REFUSE_MESSAGE: 'Vaše objednávka byla odmítnuta!',
  ORDER_SENT: 'Vaše objednávka byla odeslána!',
  PROSSECCING_TO_COOK: 'Pokračování Nabízím',
  SET_VISIBLE: 'Chystáte se nastavit toto jídlo jako neviditelné.',
  VISIBLE_MESSAGE: `To může být užitečné, pokud víte, že budete jídlo později vařit
  a nechcete je smazat.`,
  DONT_SHOW_AGAIN: 'Nezobrazovat znovu',
  LOGIN_MODAL: 'Pro objednání musíte vytvořit účet nebo se přihlásit!',
  TAKE_A_MOMENT: 'Bude to chvíli trvat.',
  NO_CHAT_MESSAGE: 'Zatím nemáte žádné zprávy',
  OFFER_ORDER: 'Vyměnit',
  ADDRESS: 'Adresa',
  ADDRESS_NOTES: 'Poznámka (patro, číslo bytu, atd.)',
  IMAGE_NOTE: '*obrázek by měl mít maximální velikost 400 kB',

  'Sending Order': 'Odeslání objednávky',
  'Logging in': 'Přihlašování',
  'accepted order': 'přijatá objednávka',
  REPORT_MESSAGE: 'Děkujeme za vaši zprávu. Prozkoumáme to co nejdříve.',
  'Adding Report': 'Přidání zprávy',
  CREATE_PROFILE: 'Vytvořit profil',
  // BUTTONS
  SEND_ORDER: 'Pošli Objednávku',
  NAVIGATE: 'Navigovat',
  SKIP: 'Přeskočit',
  SUBMIT: 'Poslat',
  'Signing you up': 'Vaše registrace',
  'Creating profile': 'Vytváření profilu',

  // AUTHENTICATION
  CREATE_AN_ACCOUNT: 'Vytvořit účet',
  OR_SIGN_IN: 'Zaregistruj se',
  EMAIL_LOGIN: 'Přihlaš se přes email',
  FACEBOOK_LOGIN: 'Přihlaš se přes Facebook',
  GOOGLE_LOGIN: 'Přihlaš se přes Google účet',
  LOGIN: 'Přihlásit se',
  PASSWORD: 'Heslo',
  PASSWORD_AGAIN: 'Zopakujte heslo',
  NAME: 'Jméno ',
  SURNAME: 'Příjmení',
  CREATE_ACCOUNT: 'Vytvoř účet',
  CREATE: 'Vytvoř',
  I_AGREE_WITH: 'Souhlasím s',
  TERMS_AND_CONDITIONS: 'Pravidly a Podmínkami',
  FORGOT_PASSWORD: 'Zapomenuté heslo',
  FORGOT_YOUR_PASSWORD: 'Zapomenuté heslo?',
  TO_RESET_PASSWORD: 'Chcete-li obnovit své heslo, zadejte svůj e-mail.',
  PASSWORD_SENT: 'Heslo bylo zasláno na váš e-mail.',
  ADMIN_LOGIN: 'Přihlaste se jako správce',
  CREATE_COOK_ACCOUNT: 'Vytvořit účet “Nabízím”',
  CREATE_GUEST_ACCOUNT: 'Vytvořit účet “Hledám”',
  COOKIES:
    'Abychom vylepšili naše webové stránky a poskytli vám personalizované služby, rádi bychom do vašeho zařízení ukládali soubory cookie. ',
  READ_MORE: 'Přečtěte si více.',

  //Welcome screen
  GUEST_DESCRIPTION: 'Chci nakoupit chutná jídla od různých kuchařů',
  COOK_DESCRIPTION: 'Chci prodat své menu a vařit s láskou k hostům',
  GUEST_BUY_DESCRIPTION: 'Chci najít',
  GUEST_SELL_DESCRIPTION: 'Chci nabídnout',
  I_AM_GUEST: `Hledám`,
  I_AM_COOK: `Nabízím`,

  //Date Picker Weekdays
  Mo: 'Po',
  Tu: 'Út',
  We: 'St',
  Th: 'Čt',
  Fr: 'Pá',
  Sa: 'So',
  Su: 'Ne',
  //Date Picker Months
  January: 'Leden',
  February: 'Únor',
  March: 'Březen',
  April: 'Duben',
  May: 'Květen',
  June: 'Červen',
  July: 'Červenec',
  August: 'Srpen',
  September: 'Září',
  October: 'Říjen',
  November: 'Listopad',
  December: 'Prosinec',

  //Restrictions
  'Dairy Free': 'Bez laktózy',
  'Gluten Free': 'Bezlepkový',
  Halal: 'Halal',
  Kosher: 'Kosher',
  'Nut Free': 'Bez ořechů',
  Organic: 'Bio',
  Vegan: 'Vegan',
  Vegetarian: 'Vegetarian',
  'Low Carb': 'Low Carb',
  Fitness: 'Fitness',
  'Sugar Free': 'Bez cukru',
  Paleo: 'Paleo',
  GENERAL: 'Bez omezení',

  //ERROR HANDLER
  INPUT_FIRST_NAME: 'Prosím, vyplňte vaše křestní jméno! ',
  INPUT_LAST_NAME: 'Prosím, vyplňte vaše příjmení!',
  INPUT_USERNAME: 'Prosím, vyplňte vaše uživatelské jméno!',
  INPUT_DESCRIPTION: 'Prosím, vyplňte váš popis!',
  INPUT_PHONE_NUMBER: 'Prosím, vyplňte vaše telefoní číslo!',
  INPUT_STREET: 'Prosím, vyplňte adresu!',
  INPUT_CITY: 'Prosím, vyplňte město!',
  TIME_ERROR: 'Zadejte odpovídající čas.',
  CONSUMPTION_ERROR: 'Prosím, vyberte možnost spotřeby',
  DATE_ERROR: 'Prosím, vyberte datum a čas',
  IMAGE_UPLOAD_ERROR: 'Nahrajte prosím obrázek',
  MEAL_NAME_ERROR: 'Prosím, zadejte název jídla!',
  MEAL_DESCRIPTION_ERROR: 'Vyplňte prosím popis jídla!',
  PRICE_ERROR: 'Zadejte prosím cenu',
  RESCTRICTED_MESSAGE: 'Zadali jste omezená slova.',

  // SUCCESS HANDLER
  'Profile Updated': 'Profil byl aktualizován',
  'Something went wrong': 'Něco se pokazilo',

  //meal filter
  'Meal Filter': 'Filtr jídla',
  Filter: 'Filtr',
  LOCATION: 'Místo',
  NEAREST: 'Nejbližší',
  FROM: 'Od',
  TO: 'Do',
  SET: 'Nastavit',
  MAX_PRICE: 'Max cena',

  //update profile
  EDIT_PROFILE_HEADER_COOK: 'Vytvořte profil podle nabídky',
  EDIT_PROFILE_HEADER_GUEST: 'Vytvořit profil, jak hledám',
  //Edit meal
  'Edit Offer': 'Upravit nabídku',
  'Editing Offer': 'Úpravy nabídky',
  MAX_TIME: 'Max. Čas',
  //Edit meal error
  FILL_TITLE: 'Prosím, zadejte název jídla!',
  FILL_DESCRIPTION: 'Vyplňte prosím popis jídla!',
  FILL_PRICE: 'Zadejte prosím cenu',

  // PRODUCT CATEGORIES
  Handyman: 'Hodinový manžel',
  Services: 'Služby',
  Crafts: 'Řemesla',
  Tools: 'Nářadí',

  'Friuts and vegetables': 'Ovoce a zelenina',
  'Pickles, jams, marmelades': 'Zavařeniny',
  'Ready meals': 'Hotové jídlo',
  Sweets: 'Sladké',
  'Bakery products and pastry': 'Pečivo a sladké pečivo',
  Herbs: 'Bylinky',
  'Garden surpluses': 'Přebytky ze zahrádky',

  'Cosmetics, beauty and health': 'Kosmetika, krása a zdraví',
  Elecrtonics: 'Elektronika',

  'Kitchen and accessories': 'Kuchyně a kuchyňské doplňky',
  Cooking: 'Vaření a stolování',
  'Bathroom and accessories': 'Koupelna a koupelnové doplňky',
  Furniture: 'Nábytek',
  'Small furniture': 'Drobný nábytek',
  Matraces: 'Matrace',
  Decorations: 'Dekorace',
  'Home accessories': 'Bytové doplňky',
  'Home textile': 'Bytový textil',
  'Pictures and frames': 'Obrazy a rámy',
  Mirrors: 'Zrcadla',
  'Carpets and floorings': 'Koberce a podlahy',
  Heaters: 'Topná tělesa',
  Lights: 'Osvětlení',
  Ventilators: 'Ventilátory',
  'Collecting, antique, arts': 'Umění, starožitnosti, sběratelství',

  'Garden furniture': 'Zahradní nábytek',
  Garden: 'Zahrada',
  Flowers: 'Rostliny',
  Grilling: 'Grilování',
  'Dools and accessories': 'Bazén a bazénové potřeby',

  Clothes: 'Oblečení',
  Shoes: 'Obuv',
  'Bags and luggages': 'Kabelky a zavazadla',

  'Childerns accessories': 'Dětské potřeby',
  'Childrens furniture': 'Dětský nábytek',
  'Childrens clothes': 'Dětské oblečení',
  'Childrens shoes': 'Dětská obuv',
  Toy: 'Hračky',
  'Books and textbooks': 'Knihy a učebnice',
  'Video games, films, CDs': 'Videohry, filmy, CD',
  'Music and musical instruments': 'Hudba a hudební nástroje',

  'Sport accessories': 'Sportovní potřeby',
  'Sport clothes': 'Sportovní oblečení',

  Cars: 'Auto',
  Motorbiking: 'Motocykly',
  Cykling: 'Cyklistika',

  'For pets': 'Pro mazlíčky',
  Others: 'Ostatní',

  // CARDS AND BANK DETAILS
  PAYMENT_CARD: 'Platební karta',
  NEW_CARD: 'Nová karta',
  BANK_ACCOUNT: 'Bankovní účet',
  NEW_ACCOUNT: 'Nový účet',
  ACCOUNT_DETAILS: 'Detail účtu',

  CARD_DETAILS: 'Detail karty',
  CARD_NUMBER: 'Číslo karty',
  CARDHOLDER_NAME: 'Jméno držitele',
  IBAN: 'IBAN',
  ACCOUNT_NUMBER: 'Číslo účtu',
  SWIFT_CODE: `SWIFT Kód/BIC`,
  BANK_NAME: 'Jméno banky',
  BANK_ADDRESS: 'Adresa banky',

  INVALID_CARD_NUMBER: 'Neplatná karta',
  INVALID_CARD_EXPIRATION: 'Platnost platební karty vypršela',
  INVALID_CVV: 'CCV je neplatné',

  EMPTY_PAYMENT_CARDS: `Žádná karta nepřidána.`,
  EMPTY_BANK_ACCOUNT: `Žádný účet nepřidán.`,
  DELETE_THIS_CARD: 'Opravdu chcete smazat tuto kartu?',
  PAYMENT_THRESHOLD: 'Limitní částka',
  PAYMENT_THRESHOLD_MESSAGE:
    'Obdržíte platbu až jakmile dosáhnete částku zde nastavenou.',

  INPUT_HOLDERS_NAME: `Prosím vložte jméno držitele!`,
  INPUT_ACCOUNT_NUMBER: `Prosím vložte číslo účtu!`,
  INPUT_IBAN: 'Prosím vložte IBAN!',
  INPUT_SWIFT_CODE: 'Prosím vložte SWIFT Kód/BIC',
  INPUT_BANK_NAME: 'Prosím vložte název banky!',
  INPUT_BANK_ADDRESS: 'Prosím vložte adresu banky!',
  INPUT_PAYMENT_THRESHOLD: 'Prosím vložte Limitní částku!',

  //Change password
  STAY_LOGGED: ' Zůstat přihlášen',
  CURRENT_PASSWORD: 'Aktuální heslo',
  NEW_PASSWORD: 'Nové heslo',
  PASSWORD_INVALID: 'Aktuální heslo je neplatné.',
  PASSWORD_CHARACTERS: 'Heslo by mělo mít alespoň 6 znaků.',
};

export default translationCZ;
